import { apiClient } from '@/services/ApiClient.js'

export default {
  getRefunds(query = {}) {
    return apiClient
      .get('tmks/refunds', { params: query })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },

  importRefunds(form) {
    let formData = new FormData()
    formData.append('file', form.file)

    return apiClient
      .postForm('tmks/import-refunds', formData)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },

  exportRefunds(query) {
    return apiClient
      .get('tmks/export-refunds', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },

  getOrderTransactions(orderId) {
    return apiClient
      .get(`tmks/${orderId}/transactions`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
